<template>
  <v-list class="pa-1">
    <v-list-tile avatar tag="div">
      <v-list-tile-avatar tile>
        <img :src="club.logo">
      </v-list-tile-avatar>

      <v-list-tile-content>
        <v-list-tile-title>{{ $store.state.authUser }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>

export default {
  props: {
    club: Object
  }
}
</script>
